export const TOKEN = '__t_'
export const USER = '__u_'
export const LANG = 'i18nextLng'
export const MENU = 'menu_state'
export const STORE = '__s_'
export const DATE_TV = '__dtv_'
export const DATE_SCORE_TV = '__dstv_'
export const IMPORT = '__upf_'
export const MENU_STATE_KEY = '__menu-state_'
